import { useState } from "react";
import { toast } from "sonner";
import { inspectionApi } from "./api";

export const DimsRow = ({ insp, room, onSaved }) => {
  const cur = insp.dimensions?.[room.key] || {};
  const [d, setD] = useState({ length_ft: cur.length_ft || "", width_ft: cur.width_ft || "", ceiling_ft: cur.ceiling_ft || 8 });
  const [busy, setBusy] = useState(false);
  const locked = insp.status === "completed";
  const tid = `insp-dims-${room.key}`;

  const save = async () => {
    setBusy(true);
    try {
      const res = await inspectionApi.dims(insp.inspection_id, { room_key: room.key, length_ft: +d.length_ft, width_ft: +d.width_ft, ceiling_ft: +d.ceiling_ft });
      onSaved(room.key, res.dimensions, res.auto_spec);
      toast.success(`${room.label}: ${res.dimensions.sq_ft} sq ft · hardware spec updated`);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };
  const inp = (k, label) => (
    <label className="insp-field">{label}
      <input type="number" step="0.1" min="1" value={d[k]} disabled={locked} onChange={(e) => setD((x) => ({ ...x, [k]: e.target.value }))} data-testid={`${tid}-${k}`} />
    </label>
  );
  return (
    <div data-testid={tid}>
      <div className="insp-step-label">Room size · drives auto-spec{cur.sq_ft ? ` · ${cur.sq_ft} sq ft` : ""}</div>
      <div className="insp-dims">
        {inp("length_ft", "Length (ft)")}{inp("width_ft", "Width (ft)")}{inp("ceiling_ft", "Ceiling (ft)")}
        <button type="button" className="insp-btn" disabled={busy || locked || !d.length_ft || !d.width_ft} onClick={save} data-testid={`${tid}-save`}>{busy ? "…" : "Save"}</button>
      </div>
    </div>
  );
};
